import React from "react";
import { defaultSortDirection } from "views/logic/widgets/MessagesWidgetConfig";
import Direction from "views/logic/aggregationbuilder/Direction";
import SortConfig from "views/logic/aggregationbuilder/SortConfig";
import { SortIcon } from "components/common";
const _tooltip = (fieldName, newDirection) => `Sort ${fieldName} ${newDirection.direction}`;
const _changeSort = (nextDirection, _config, fieldName, onSortChange, setLoadingState) => {
  const newSort = [new SortConfig(SortConfig.PIVOT_TYPE, fieldName, nextDirection)];
  setLoadingState(true);
  onSortChange(newSort).then(() => {
    setLoadingState(false);
  });
};
const _isFieldSortActive = (config, fieldName) => config.sort && config.sort.length > 0 && config.sort[0].field === fieldName;
const DirectionStrategyAsc = {
  tooltip: (fieldName) => _tooltip(fieldName, Direction.Descending),
  handleSortChange: (changeSort) => changeSort(Direction.Descending)
};
const DirectionStrategyDesc = {
  tooltip: (fieldName) => _tooltip(fieldName, Direction.Ascending),
  handleSortChange: (changeSort) => changeSort(Direction.Ascending)
};
const DirectionStrategyNoSort = {
  tooltip: (fieldName) => _tooltip(fieldName, defaultSortDirection),
  handleSortChange: (changeSort) => changeSort(defaultSortDirection)
};
const _directionStrategy = (config, fieldName) => {
  const fieldSortDirection = _isFieldSortActive(config, fieldName) ? config.sort[0].direction.direction : null;
  switch (fieldSortDirection) {
    case Direction.Ascending.direction:
      return DirectionStrategyAsc;
    case Direction.Descending.direction:
      return DirectionStrategyDesc;
    default:
      return DirectionStrategyNoSort;
  }
};
const FieldSortIcon = ({ fieldName, config, onSortChange, setLoadingState }) => {
  const changeSort = (nextDirection) => _changeSort(nextDirection, config, fieldName, onSortChange, setLoadingState);
  const activeDirection = _isFieldSortActive(config, fieldName) ? config.sort[0].direction.direction : null;
  const { tooltip, handleSortChange } = _directionStrategy(config, fieldName);
  return /* @__PURE__ */ React.createElement(
    SortIcon,
    {
      activeDirection,
      onChange: () => handleSortChange(changeSort),
      title: tooltip(fieldName)
    }
  );
};
export default FieldSortIcon;
